module.exports = __webpack_public_path__ + "static/1_1_defineai_MT-40c40906c60114cad72c9e1bddf0ba23.svg";